import { Button } from '@mui/material';
import React, { useContext, useState } from 'react';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import AddEpisodeDialog from './Dialogs/AddEpisodeDialog';

export default function AddEpisodeButton() {
    const { selectedSeason } = useContext(SeasonShowContext);
    const [addOpen, setAddOpen] = useState(false);


    return (
        <>
            <Button
                color='primary'
                variant='contained'
                onClick={() => setAddOpen(true)}
                disabled={!selectedSeason}
            >
                Add Episode
            </Button>
            <AddEpisodeDialog open={addOpen} onClose={() => setAddOpen(false)} />
        </>
    )
}